import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AccountProductType } from '@models/account.model'
import { AccountService } from '@services/account.service'

export const supplierProductGuard: CanActivateFn = () => {
	const accountService = inject(AccountService)
	const router = inject(Router)

	if (!accountService.isSupplier) {
		return router.createUrlTree(['/dashboard'])
	}

	const currentProductType = accountService.currentProduct?.type

	if (currentProductType !== AccountProductType.SUP) {
		accountService.changeProduct(AccountProductType.SUP)
	}

	return true
}
